import { z } from "zod";
import { MediaSchema } from "../Media";
import { ResponsiveImageSchema } from "../Media/deprecated-image-schema";
export const WebActionTypeSchema = z.nativeEnum({
    ShowRsoModal: "show_rso_modal",
    Weblink: "weblink",
    YoutubeVideo: "youtube_video",
    ImageViewer: "image_viewer",
    MediaViewer: "media_viewer",
    ClientDeepLink: "client_deeplink",
});
export const WebActionType = WebActionTypeSchema.enum;
export const ShowRsoModalActionSchema = z.object({
    type: z.literal(WebActionType.ShowRsoModal),
    payload: z.object({ url: z.string().optional(), isPbeAuth: z.boolean().optional() }).optional(),
});
const WebLinkPayloadSchema = z.object({
    url: z.string(),
    isExternal: z.boolean().optional(),
    eventTrackingType: z.string().optional(),
});
const WebLinkActionSchema = z.object({
    type: z.literal(WebActionType.Weblink),
    requiresAuthentication: z.boolean().optional(),
    payload: WebLinkPayloadSchema,
});
const YoutubeVideoPayloadSchema = z.object({
    url: z.string(),
    youtubeId: z.string(),
    allowFullScreen: z.boolean().optional(),
});
const YoutubeVideoActionSchema = z.object({
    type: z.literal(WebActionType.YoutubeVideo),
    payload: YoutubeVideoPayloadSchema,
});
const ImageViewerPayloadSchema = z.object({
    image: ResponsiveImageSchema,
});
const ImageViewerActionSchema = z.object({
    type: z.literal(WebActionType.ImageViewer),
    payload: ImageViewerPayloadSchema,
});
const MediaViewerPayloadSchema = z.object({
    media: MediaSchema,
});
const MediaViewerActionSchema = z.object({
    type: z.literal(WebActionType.MediaViewer),
    payload: MediaViewerPayloadSchema,
});
export const ClientDeepLinkPayloadSchema = z.object({
    uri: z.string(),
});
export const ClientDeepLinkActionSchema = z.object({
    type: z.literal(WebActionType.ClientDeepLink),
    payload: ClientDeepLinkPayloadSchema,
});
export const AnyWebActionSchema = z.discriminatedUnion("type", [
    WebLinkActionSchema,
    ShowRsoModalActionSchema,
    YoutubeVideoActionSchema,
    ImageViewerActionSchema,
    MediaViewerActionSchema,
    ClientDeepLinkActionSchema,
]);
export const ActionSchema = AnyWebActionSchema;
export function isValidAction(obj) {
    return AnyWebActionSchema.safeParse(obj).success;
}
//# sourceMappingURL=index.js.map